import { ImgElement } from '@axinom/mosaic-ui';
import { config } from 'config';
import { SSOResponseCode } from 'models/ssoTypes';
import React, { useEffect, useState } from 'react';
import { getSSOToken } from 'util/ssoTokenUtils';
import logo from '../../../images/AP_logo.png';
import logoPortal from '../../../images/Logo_Portal.png';
import { authStateStore } from '../../../state-store';
import classes from './SsoSignIn.module.scss';

export const SsoSignIn: React.FC = () => {
  const [renderComponent, setRenderComponent] = useState(false);
  const ssoContext = authStateStore.useState('ssoContext');

  useEffect(() => {
    if (
      ssoContext.signInStatus === false &&
      ssoContext.ssoError === undefined
    ) {
      (async (): Promise<void> => {
        await getSSOToken();
      })();
    }
    if (
      ssoContext.ssoError !== undefined &&
      ssoContext.ssoError.code === SSOResponseCode.NOT_LOGGED_IN
    ) {
      setRenderComponent(true);
    }
  }, [ssoContext.signInStatus, ssoContext.ssoError]);

  const handleSignIn = async (): Promise<void> => {
    if (config.axinomPortalBaseUrl !== undefined) {
      const loginURL = new URL(
        `/login?returnUrl=${window.location.href}`,
        config.axinomPortalBaseUrl,
      ).toString();
      window.location.href = loginURL;
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        {renderComponent && (
          <div className={classes.box}>
            <div className={classes.logo}>
              <ImgElement src={logo} alt="Administration Portal" />
            </div>
            <div className={classes.title}>Sign In</div>
            <div className={classes.subText}>
              Sign In using your Axinom Portal credentials
            </div>
            <div
              className={classes.button}
              onClick={handleSignIn}
              data-test-id="axinom-portal-sign-in-button"
            >
              <ImgElement
                src={logoPortal}
                className={classes.logoPortal}
                alt="Axinom Portal"
              />
              Axinom Portal Sign In
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
